import * as React from 'react';
export const IcHcvTop = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 11v-.76a2 2 0 00-.21-.9L17 7.76V7h1a1 1 0 100-2h-1v-.5a1 1 0 00-.17-.5c-.13-.25-1.39-2-4.83-2-3.44 0-4.7 1.75-4.83 2a1 1 0 00-.17.5V5H6a1 1 0 000 2h1v.76l-.79 1.58a2 2 0 00-.21.9V11a2 2 0 00-2 2v4a2 2 0 002 2 3 3 0 003 3h6a3 3 0 003-3 2 2 0 002-2v-4a2 2 0 00-2-2zm-7 7a1 1 0 01-2 0v-8a1 1 0 012 0v8zm4 0a1 1 0 01-2 0v-8a1 1 0 012 0v8zm-.33-12H9.33A.33.33 0 019 5.67 1.67 1.67 0 0110.67 4h2.66A1.67 1.67 0 0115 5.67a.33.33 0 01-.33.33z'
      fill='currentColor'
    />
  </svg>
);
